import React from 'react';
import './Footer.css';

const Footer = (props) => {
  return (
    <div className='footer'>
      <a href="http://bdmenterprises.com" target="_blank" rel="noopener noreferrer"><h4>© 2017 BDM Enterprises, Inc.</h4></a>
    </div>
  );
};

export default Footer;


// WEBPACK FOOTER //
// ./src/components/Footer.js